import React, { Dispatch, FC, SetStateAction } from "react";
import { defineMessages, useIntl } from "react-intl";
import {
  RatingItemType,
  EMPTY_RATING,
  FeedbackDataType,
  ratingItems,
  npsScoreItems,
  FeedbackTypes,
} from "@app/pippa/models";
import ScoresRating from "./scoresRating";

interface Props {
  feedback: FeedbackDataType;
  rating: number;
  setSelectedRatingItem: Dispatch<SetStateAction<RatingItemType>>;
  isDisabled: boolean;
}

const messages = defineMessages({
  scoreRatingList: {
    id: "scoreRatingList",
    defaultMessage: "Select answer",
  },
});

const Rating: FC<Props> = ({
  feedback,
  rating,
  setSelectedRatingItem,
  isDisabled,
}) => {
  const intl = useIntl();
  const items =
    feedback.type === FeedbackTypes.CSAT ? ratingItems : npsScoreItems;

  const onClickHandler = (item: RatingItemType) => {
    if (isDisabled) return;

    setSelectedRatingItem(item.scoreNumber === rating ? EMPTY_RATING : item);
  };

  const ariaLabel = intl.formatMessage(messages.scoreRatingList);

  return (
    <div className="rating__container">
      <ul className="rating__list score-type" aria-label={ariaLabel}>
        {items.map((item) => (
          <ScoresRating
            key={item.scoreNumber}
            item={item}
            isDisabled={isDisabled}
            rating={rating}
            feedbackType={feedback.type}
            onClickHandler={onClickHandler}
          />
        ))}
      </ul>
    </div>
  );
};

export default Rating;
